import origin from '../lib/origin';

const BASE_URL = origin();

export const api = {
  ez_pay: {
    hostInstances: 'https://api.dev.kubra.io/ez-pay/v1',
  }
};

const authConfig = {
  clientId: 'PcggvMMnn7EzE9POSiz9CN4XtibvBfD2',
  origin: 'auth0.kubra.io',
  audience: 'https://kubra.io/api',
  silentCallbackPath: `${BASE_URL}/login/silent-callback`,
  callbackPath: `${BASE_URL}/login/callback`,
  logoutPath: `${BASE_URL}/login/logout`,
  responseType: 'token id_token',
  scope: 'openid profile name email',
  useCookies: false,
  redirectToCaller: true,
  allowUrlConfig: '',
};

const googleAnalyticsCode = 'G-EWSRXD93X2';

//GoogleMaps api key
const googlemapsApiKey = 'AIzaSyD-3r5UjRnWMD2z0VEC_XQye510slIxxlQ';

const awsWafUrl = "https://4d640c2bc052.edge.sdk.awswaf.com/4d640c2bc052/a119faca5e6e/challenge.js";

export default {
  api,
  auth: authConfig,
  googleAnalyticsCode,
  googlemapsApiKey,
  awsWafUrl
};
